import { ChatGPTIcon } from "./icons/chatgpt-icon";
import { ClaudeIcon } from "./icons/claude-icon";
import { GeminiIcon } from "./icons/gemini-icon";
import { PerplexityIcon } from "./icons/perplexity-icon";
import { MetaIcon } from "./icons/meta-icon";
import { GoogleAIModeIcon } from "./icons/google-ai-mode-icon";
import { GoogleAIOIcon } from "./icons/google-aio-icon";

export type ValidPlatform = 
  | "chatgpt"
  | "claude"
  | "google_gemini"
  | "perplexity"
  | "meta"
  | "google_ai_mode"
  | "google_ai_overviews";

type PlatformIconProps = {
  platform: ValidPlatform;
  size?: number;
  className?: string;
};

export function PlatformIcon({ platform, size = 18, className }: PlatformIconProps): JSX.Element {
  switch (platform) {
    case "chatgpt":
      return <ChatGPTIcon size={size} className={className} />;
    case "claude":
      return <ClaudeIcon size={size} className={className} />;
    case "google_gemini":
      return <GeminiIcon size={size} className={className} />;
    case "perplexity":
      return <PerplexityIcon size={size} className={`[&>path]:!fill-foreground ${className || ''}`} />;
    case "meta":
      return <MetaIcon size={size} className={className} />;
    case "google_ai_mode":
      return <GoogleAIModeIcon size={size} className={className} />;
    case "google_ai_overviews":
      return <GoogleAIOIcon size={size} className={className} />;
    default:
      return <></>;
  }
}
